import { useState } from "react";
import { FilterButtons } from "./FilterButtons";
import { useEffect } from "react";
import { usersByType } from "../../../callable-cloud-functions/cloudFunctions";
import {useCountActiveUsersByDays, useUsersCountAdmin } from "../../../data/user";
import { fetchMonthlyActiveLoginCount, fetchMonthlyActiveUsers, fetchPlatformWiseActiveUsers, fetchActiveUsersPlatformWiseCSV } from "../../../data/loginActivity";
import SeekerActivityChart from "./A_Components/SeekerActivityCharts";
import { csvDownload } from "../AdminMetricDashboard/ExportCsv";
// import { getActiveUsersCSVData } from "../../../callable-cloud-functions/cloudFunctions";
import ActiveUserByPlatformChart from "./A_Components/ActiveUserByPlatformCharts";
import { Download } from "lucide-react";
import { formatUSNumber } from "./helper";
import { getRangeExportSlug } from "../../../utils/insighthubDateRange";


const Seekers = () => {
    const [selectedDays, setSelectedDays] = useState(7);
    const [activeAndNewUserData,setActiveandNewUserData] = useState({activeUsers:0,newUsers:0});
    const { data } = useUsersCountAdmin()

    const [seekerData, setSeekerData] = useState([]);
    const [loadingStates, setLoadingStates] = useState({
        interactionsloading: false,
        activeUserloading: false,
        downloadMauLoading:false
    });
    const [mau30Days, setMau30Days] = useState(0);
    const [platformWiseData, setPlatformWiseData] = useState();

    const getSelectedRangeLabel = (days: number) => {
        if (days === 90) {
            return "Last Quarter";
        }
        if (days === 365) {
            return "Last Year";
        }
        return `Last ${days} days`;
    };


    useEffect(() => {
        async function fetchMAU() {
            try {
            const res = await fetchMonthlyActiveLoginCount();
            setMau30Days(res.count);
            } catch (error) {
            console.error("Error fetching MAU:", error);
            setMau30Days(0);
            }
        }

        fetchMAU();
    }, []);

    useEffect(() => {
        async function fetchPlatformData() {
            try {
            const res = await fetchPlatformWiseActiveUsers(selectedDays);
            setPlatformWiseData(res);
            } catch (error) {
            console.error("Error fetching platform-wise users:", error);
            setPlatformWiseData(null);
            }
        }

        fetchPlatformData();
    }, [selectedDays]);

    useEffect(() => {
        async function fetchData() {
            const { data }: any = await usersByType();
            setSeekerData(data);
        }
        fetchData();
    }, []);


    const handleCsvDownload = async (
        fetchDataFunc: any,
        loadingKey: any,
        fileName: any,
        options?: { fileSuffix?: string }
    ) => {

        setLoadingStates((prevState: any) => ({ ...prevState, [loadingKey]: true }));

        const data = await fetchDataFunc({
            days: selectedDays,
            selection: selectedDays,
        })
        setLoadingStates((prevState: any) => ({ ...prevState, [loadingKey]: false }));
        if (data?.data?.data) {

            const suffix = options?.fileSuffix ?? `${selectedDays}_days`;
            csvDownload(data?.data?.data, `${fileName}_${suffix}`)
        } else {
            console.log("no data found")
        }
    }


    return (
        <div className="bg-white pr-2">
            {/* Header */}
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold text-instant-teams-blue-Main text-foreground">
                    Seekers Overview
                </h2>
                {/* <FilterButtons selected={selectedDays} onSelect={setSelectedDays} /> */}
            </div>

            {/* Summary Section */}
            <div className="mt-6 border  rounded-lg border-[#bad5f1]  bg-[#E6F1FC] p-8">
                {/* Summary Header */}
                <h3 className="text-[22px] font-semibold text-instant-teams-blue-Main mb-6">Summary</h3>

                {/* Top Stats */}
                <div className="grid  grid-cols-4 gap-6">
                    <div>
                        <p className="text-sm text-gray-500">Total Seekers</p>
                        <p className="text-2xl font-bold text-[#183853]">{seekerData?.Seekers? formatUSNumber(seekerData?.Seekers): "..."}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Active Seekers</p>
                        <p className="text-2xl font-bold text-[#183853]">{data?.activeCount?formatUSNumber(data?.activeCount):"..."}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Community Users</p>
                        <p className="text-2xl font-bold text-[#183853]">{seekerData?.Community? formatUSNumber(seekerData?.Community) :"..."}</p>
                    </div>
                    <div>
                        <p className="text-sm text-gray-500">Total Self-Affiliated</p>
                        <p className="text-2xl font-bold text-[#183853]">{seekerData?.Affiliated? formatUSNumber(seekerData?.Affiliated) :"..."}</p>
                    </div>
                </div>

                {/* Divider */}
                <hr className="my-8 border-[#bad5f1]  bg-[#E6F1FC]" />

                {/* Breakdown Section */}
                <div>
                    <p className="text-lg font-semibold text-instant-teams-blue-Main mb-4">
                        Self-Affiliated Breakdown
                    </p>
                    <div className="grid grid-cols-4 gap-6">
                        {Object.entries(seekerData?.affiliationTypes || {}).map(([key, value]: any) => (
                            <div
                                key={key}
                                className="  bg-[#E6F1FC]    "
                            >
                                <p className="text-sm text-gray-500 ">{key}</p>
                                <p className="text-2xl font-bold text-[#183853] mt-1">{value?formatUSNumber(value) :""}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-5 flex w-full justify-start" >
                <FilterButtons selected={selectedDays} onSelect={setSelectedDays} />
            </div>

            <div className="grid  grid-cols-3 gap-5">
                <div className="mt-6 border border-gray-200 rounded-lg bg-white p-8">
                    <p className="text-sm text-gray-500">Total Active Seekers <span>{`( ${getSelectedRangeLabel(selectedDays)} )`}</span></p>
                    <p className="text-2xl font-bold text-[#183853]">{activeAndNewUserData?.activeUsers || 0}</p>
                </div>
                <div className="mt-6 border border-gray-200 rounded-lg bg-white p-8">
                    <p className="text-sm text-gray-500">New Registrations <span>{`( ${getSelectedRangeLabel(selectedDays)} )`}</span></p>
                    <p className="text-2xl font-bold text-[#183853]">{activeAndNewUserData?.newUsers || 0}</p>
                </div>
                <div className="mt-6 border border-[#bad5f1]  bg-[#E6F1FC] rounded-lg  p-8">
                    <div className="flex cursor-pointer  justify-between">
                        <p className="text-sm text-instant-teams-blue-Main">Monthly Unique Active Seekers</p>
                        <button className="flex mr-[-15px] items-center border bg-white border-gray-300 text-gray-700 hover:bg-gray-100 px-3 py-1 rounded-md text-sm"

                            onClick={() => { handleCsvDownload(fetchMonthlyActiveUsers, "downloadMauLoading", "MAU(last 30 days)") }}
                        >
                            <Download className="h-4 w-4 mr-2" />
                            <p>{loadingStates?.downloadMauLoading?"Downloading...":"Download"}</p>
                        </button>
                    </div>

                    <p className="text-2xl mt-[-10px] font-bold text-[#183853]">{mau30Days}</p>
                </div>

            </div>

            <div className="w-full mt-5">
                <SeekerActivityChart setActiveandNewUserData={setActiveandNewUserData} daysSelected={selectedDays} />
            </div>

            <div className="mt-5 w-[50%]">
                <ActiveUserByPlatformChart
                    extdata={platformWiseData}
                    chartFlag='User'
                    daysSelected={selectedDays}
                    handleCSVDowload={() => {
                        handleCsvDownload(
                            fetchActiveUsersPlatformWiseCSV,
                            "activeUserloading",
                            "active_users_by_platform",
                            { fileSuffix: getRangeExportSlug(selectedDays) }
                        );
                    }}
                    donwlodingState={loadingStates}
                />
            </div>
        </div>
    );
};

export default Seekers;
